/* NordiSignal Shopify adapter. Real IDs are supplied by the product JSON metafield. */
(() => {
  'use strict';
  const read = id => { try { return JSON.parse(document.getElementById(id)?.textContent || 'null') || {}; } catch { return {}; } };
  const config = read('nsn-commerce-config');
  const catalog = read('nsn-commerce-catalog');
  let busy = false;
  const keyFor = state => state.package + ':' + state.colors.join('|');
  function buildItems(state, cfg = config, stock = catalog) {
    if (cfg.enabled !== true) throw new Error('Diese Auswahl ist derzeit nicht verfügbar.');
    const id = cfg.variants?.[keyFor(state)];
    const main = (stock.main || []).find(v => String(v.id) === String(id));
    if (!id || !main || !main.available) throw new Error('Diese Farbkombination ist derzeit nicht verfügbar.');
    if (Number(main.price) !== state.packageCents) throw new Error('Das Angebot wird gerade aktualisiert. Bitte lade die Seite erneut.');
    const properties = {'Radio 1': state.colors[0]};
    if (state.colors[1]) properties['Radio 2'] = state.colors[1];
    const items = [{id: String(id), quantity: 1, properties}];
    if (state.addonHeadlamps) {
      const lampId = cfg.headlamp_variant_id;
      const lamp = (stock.accessory || []).find(v => String(v.id) === String(lampId));
      if (!lampId || !lamp || !lamp.available) throw new Error('Die zusätzlichen Stirnlampen sind derzeit nicht verfügbar.');
      if (Number(lamp.price) !== state.addonCents / state.addonHeadlamps) throw new Error('Das Zubehörangebot wird gerade aktualisiert. Bitte lade die Seite erneut.');
      items.push({id: String(lampId), quantity: state.addonHeadlamps});
    }
    return items;
  }
  function buttons(root) {
    return [...root.querySelectorAll('[type="submit"],[data-buy-link]'), ...document.querySelectorAll('[data-nsn-external-add]')];
  }
  function status(root, message) {
    let node = root.querySelector('[data-commerce-status]');
    if (!node) { node = document.createElement('p'); node.dataset.commerceStatus = ''; node.setAttribute('role','status'); node.setAttribute('aria-live','polite'); root.querySelector('form').append(node); }
    node.textContent = message; node.hidden = !message;
  }
  function sync(root, state) {
    let error = '';
    try { buildItems(state); } catch (e) { error = e.message; }
    buttons(root).forEach(button => {button.disabled = busy || !!error; button.setAttribute('aria-disabled', String(busy || !!error));});
    status(root, error);
  }
  async function add(root, state) {
    if (busy) return;
    let items;
    try { items = buildItems(state); } catch (e) { status(root, e.message); return; }
    busy = true; sync(root,state);
    try {
      const base = window.Shopify?.routes?.root || '/';
      const response = await fetch(base + 'cart/add.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
      const body = await response.json();
      if (!response.ok) throw new Error(body.description || body.message || 'Die Auswahl konnte nicht hinzugefügt werden. Bitte versuche es erneut.');
      window.location.assign(base + 'cart');
    } catch (e) { status(root,e.message || 'Die Verbindung ist unterbrochen. Bitte versuche es erneut.'); }
    finally { busy = false; buttons(root).forEach(b=>{b.disabled=false;b.setAttribute('aria-disabled','false');}); }
  }
  window.NordiSignalCart = {buildItems, sync, add};
})();
